import { upperFirst } from 'lodash';

import { Condition, Iteration } from 'Component/others';

import { TextRegular } from 'UiKit/typography';

import Tooltip from 'UiKit/tooltip';

import styles from './styles.module.css';

const AccountColumn = ({ value }) => {
  const displayAccounts = value?.slice(0, 2) || [];
  const hiddenAccounts = value?.slice(2) || [];
  const remainingCount = hiddenAccounts?.length;

  return (
    <div className={styles['column__text']}>
      <Iteration
        items={displayAccounts}
        render={(acc, index) => (
          <TextRegular key={index}>
            <strong>{upperFirst(acc?.name)}</strong> {acc?.ecommerce}
            <Condition
              statement={index === displayAccounts.length - 1 && remainingCount > 0}
              children={
                <div style={{ display: 'inline-block' }}>
                  <Tooltip
                    label={
                      <span style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                        <Iteration
                          items={hiddenAccounts}
                          render={(acc, index) => (
                            <span key={index}>
                              {index + 1}. {upperFirst(acc?.name)} {acc?.ecommerce}
                            </span>
                          )}
                        />
                      </span>
                    }
                    children={<TextRegular className={styles['placeholder__text-more']}>+{remainingCount} more</TextRegular>}
                  />
                </div>
              }
            />
          </TextRegular>
        )}
      />
    </div>
  );
};

export default AccountColumn;
